import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useRoute, useRouter } from "vue-router";
export const ProtoPagination = {
  name: "ProtoPagination"
  // 组件定义...
};
// 为了向后兼容，也提供默认导出
const __default__ = ProtoPagination;
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'proto-pagination',
  props: {
    align: {
      type: String,
      default: "right"
    },
    total: {
      type: Number || String,
      default: 50
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next"
    },
    page: {
      type: Object,
      default: () => ({
        size: 10,
        current: 1
      })
    }
  },
  emits: ["currentChange", "sizeChange"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const emit = __emit;
    const props = __props;
    const handleSizeChange = size => {
      console.log("size", size);
      emit("sizeChange", size);
    };
    const handleCurrentChange = val => {
      // console.log('val', val)
      emit("currentChange", val);
    };
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["proto-pagination", {
          center: __props.align === 'center',
          left: __props.align === 'left',
          right: __props.align === 'right'
        }])
      }, [_createVNode(_component_el_pagination, {
        background: "",
        layout: __props.layout,
        total: __props.total,
        "current-page": __props.page.current,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => __props.page.current = $event),
        "page-size": __props.page.size,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => __props.page.size = $event),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["layout", "total", "current-page", "page-size"])], 2);
    };
  }
});